import StatisticsPID from './PID';
import StatisticsCountry from './Country';
import StatisticsGender from './Gender';
import StatisticsCoverageMap from './CoverageMap';

export {
  StatisticsCountry,
  StatisticsPID,
  StatisticsGender,
  StatisticsCoverageMap
};


// WEBPACK FOOTER //
// ./src/views/Statistics/index.js